export default __webpack_public_path__ + "static/media/double-chevron.c480b4b4.svg";